import { customAxios } from "@/shared/lib/customAxios"
import type { ListRequest, ListResponse } from "@/shared/types/commonResponse"
import { useQuery, type UseQueryResult } from "@tanstack/react-query"

// POST /star/news/list  ------------------------------ News List

export interface NewsContent {
  id: number
  starId: number
  title: string
  contents: string
  thumbImageUrl: string
  regDt: string
}

export type NewsListResponse = ListResponse<NewsContent>

const newsList = ({
  Language,
  requestDto,
  angkorId,
}: ListRequest): Promise<NewsListResponse> => {
  return customAxios
    .post<NewsListResponse>("star/news/list", requestDto, {
      headers: {
        Language: Language,
        angkorId: angkorId,
      },
    })
    .then((res) => res.data)
}

export const useNewsListQuery = (
  request: ListRequest
): UseQueryResult<NewsListResponse, Error> => {
  return useQuery<NewsListResponse, Error>({
    queryKey: ["newsList", request],
    queryFn: () => newsList(request),
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })
}

// POST /star/news/list  ------------------------------ News List

// POST /star/news/info  ------------------------------ News info

export interface NewsDetailRequest {
  Language: string
  angkorId: string
  requestDto: {
    newsId: number
  }
}

export interface NewsDetailResponse {
  id: number
  starId: number
  name: string
  title: string
  contents: string
  thumbImageUrl: string
  regDt: string
  profileUrl: string
}

const newsInfo = ({
  Language,
  requestDto,
  angkorId,
}: NewsDetailRequest): Promise<NewsDetailResponse> => {
  return customAxios
    .post<NewsDetailResponse>("star/news/info", requestDto, {
      headers: {
        Language: Language,
        angkorId: angkorId,
      },
    })
    .then((res) => res.data)
}

export const useNewsInfoQuery = (
  request: NewsDetailRequest
): UseQueryResult<NewsDetailResponse, Error> => {
  return useQuery<NewsDetailResponse, Error>({
    queryKey: ["newsInfo", request],
    queryFn: () => newsInfo(request),
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })
}

// POST /star/news/info  ------------------------------ News info
